import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import { ButtonHTMLAttributes, MouseEventHandler } from 'react';
import styles from './IconButton.module.css';

import './Buttons.scss';
import { useTheme } from 'es/app/theme';

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon: IconProp;
    disabled?: boolean;
    className?: string;
    onClick: MouseEventHandler<HTMLButtonElement>;
}

export const IconButton = (props: IProps) => {
    const { icon, disabled, onClick, ...rest } = props;
    const { themeName } = useTheme();
    const className = cn(styles.iconButton, props.className, {
        [styles.iconButtonLight ?? '']: themeName === 'light',
        [styles.iconButtonDark ?? '']: themeName === 'dark',
    });

    return (
        <button
            {...rest}
            className={className}
            onClick={e => {
                if (disabled) return;
                if (!onClick) return;
                onClick(e);
            }}
            disabled={!!disabled}
        >
            <FontAwesomeIcon icon={icon} />
        </button>
    );
};

const IconButtonHoC = (icon: IconProp) => (props: Omit<IProps, 'icon'>) => <IconButton {...props} icon={icon} />;
export const CloneIconButton = IconButtonHoC('clone');
export const AddIconButton = IconButtonHoC('plus');
export const CancelIconButton = IconButtonHoC('times');
export const DeleteIconButton = IconButtonHoC(['fal', 'trash']);
export const EditIconButton = IconButtonHoC(['fal', 'pencil-alt']);
export const TransferIconButton = IconButtonHoC(['fal', 'exchange-alt']);
export const ResetIconButton = IconButtonHoC('undo');
export const SaveIconButton = IconButtonHoC(['far', 'save']);
export const RefreshIconButton = IconButtonHoC('recycle');
export const EraseIconButton = IconButtonHoC('eraser');
